import React, { useState } from 'react';

const SCROLLBAR_STYLE = `
  .vsi-help-panel::-webkit-scrollbar { width: 4px; }
  .vsi-help-panel::-webkit-scrollbar-track { background: transparent; }
  .vsi-help-panel::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); border-radius: 4px; }
  .vsi-help-panel::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,0.22); }
`;

export default function SideHelpPanel({ title, children }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <style>{SCROLLBAR_STYLE}</style>
      {/* Toggle button — fixed to left edge, always visible */}
      <button
        style={{
          position: 'fixed',
          left: open ? 400 : 0,
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 1001,
          background: 'linear-gradient(180deg, #1e2a3a 0%, #0f1825 100%)',
          border: '1px solid rgba(255,255,255,0.15)',
          borderLeft: open ? '1px solid rgba(255,255,255,0.15)' : 'none',
          borderRadius: '0 8px 8px 0',
          color: 'rgba(255,255,255,0.75)',
          cursor: 'pointer',
          padding: '12px 7px',
          fontSize: 13,
          fontWeight: 700,
          letterSpacing: '0.08em',
          writingMode: 'vertical-rl',
          textOrientation: 'mixed',
          transition: 'left 0.28s ease',
          boxShadow: '2px 0 12px rgba(0,0,0,0.35)',
          userSelect: 'none',
        }}
        onClick={() => setOpen(o => !o)}
      >
        {open ? '✕' : 'HELP'}
      </button>

      {/* Panel */}
      <div
        className="vsi-help-panel"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: 400,
          height: '100vh',
          zIndex: 1000,
          background: 'linear-gradient(180deg, #0B0F1A 0%, #121826 100%)',
          borderRight: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '0 0 20px rgba(0,0,0,0.5), inset 0 0 40px rgba(0,0,0,0.4)',
          transform: open ? 'translateX(0)' : 'translateX(-400px)',
          transition: 'transform 0.28s ease',
          display: 'flex',
          flexDirection: 'column',
          padding: '20px 24px',
          boxSizing: 'border-box',
          overflowY: 'auto',
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontWeight: 700, fontSize: 16, color: '#FFFFFF', marginBottom: 14, paddingBottom: 6, borderBottom: '2px solid rgba(168,85,247,0.6)' }}>{title || 'Help'}</div>
          <div style={{ height: 2, width: 32, background: 'linear-gradient(90deg, #a78bfa, #f472b6)', borderRadius: 2 }} />
        </div>
        {children || (
          <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', fontStyle: 'italic', marginTop: 12 }}>
            Help content coming soon.
          </div>
        )}
      </div>

      {/* Backdrop — closes panel on click */}
      {open && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 999,
            background: 'rgba(0,0,0,0.35)',
          }}
          onClick={() => setOpen(false)}
        />
      )}
    </>
  );
}
